import React, { useState, useEffect } from 'react';
import Input from '../components/common/Input';
import { useNavigate } from 'react-router-dom';

const VerifyOtp = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        otp: ''
    });
    const [timeLeft, setTimeLeft] = useState(300); 
    const [isExpired, setIsExpired] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [resendLoading, setResendLoading] = useState(false);

    // Countdown timer effect
    useEffect(() => {
        if (timeLeft <= 0) {
            setIsExpired(true);
            return;
        }

        const timer = setTimeout(() => {
            setTimeLeft(timeLeft - 1);
        }, 1000);

        return () => clearTimeout(timer);
    }, [timeLeft]);

    // Format time as MM:SS
    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
    };

    // Determine timer color
    const getTimerColor = () => {
        if (isExpired) {
            return 'text-danger'; 
        } else if (timeLeft <= 60) {
            return 'text-warning'; 
        } else {
            return 'text-primary';
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        
        // Limit OTP to 6 digits
        if (name === 'otp' && value.length <= 6) {
            setFormData(prevState => ({
                ...prevState,
                [name]: value
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (isExpired) {
            alert('OTP has expired. Please request a new one.');
            return;
        }

        if (formData.otp.length !== 6) {
            alert('Please enter a valid 6-digit OTP.');
            return;
        }

        setIsLoading(true);
        
        try {
            // Simulate API call for OTP verification
            await new Promise(resolve => setTimeout(resolve, 1500));
            
            // For demo purposes, assuming OTP is always valid
         
            
            // Navigate to dashboard on success
            navigate('/dashboard');
        } catch (error) {
            console.error('OTP verification failed:', error);
            alert('Invalid OTP. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleResendOtp = async () => {
        if (resendLoading) return;
        
        setResendLoading(true);
        
        try {
            // Simulate API call for resending OTP
            await new Promise(resolve => setTimeout(resolve, 1000));
            
            // Reset timer and states
            setTimeLeft(300); // Reset to 5 minutes
            setIsExpired(false);
            setFormData({ otp: '' });
            
       
            alert('A new OTP has been sent to your email.');
        } catch (error) {
            console.error('Failed to resend OTP:', error);
            alert('Failed to resend OTP. Please try again.');
        } finally {
            setResendLoading(false);
        }
    };

    const handleBackToLogin = () => {
        navigate('/');
    };

    return (
        <div className="login-page">
            {/* Left Section - Welcome Content */}
            <div className="welcome-section">
                <div className="welcome-content">
                    <h1 className="welcome-title">Welcome to OpenBook</h1>
                    {/* <p className="purpose-text">Purpose</p> */}
                </div>
            </div>

            {/* Right Section - Login Form */}
            <div className="login-section">
                <div className="login-form-wrapper">
                    <div className='rockwell_logo'>
                        <img src='../../assets/Rockwell-Logo.jpg' alt='rockwell_logo' />
                    </div>
                    <div className="form-title-section">
                        <h4 className="form-title">Verify OTP</h4>
                       
                        <p className={`form-subtitle ${isExpired ? 'text-danger' : ''}`}>
                            {isExpired ? (
                                'OTP has expired. Please request a new one.'
                            ) : (
                                <>
                                    Please enter the 6-digit code from your email. Expires in{' '}
                                    <span className={getTimerColor()}>
                                        {formatTime(timeLeft)}
                                    </span>
                                    .
                                </>
                            )}
                        </p>
                    </div>
                    <form onSubmit={handleSubmit} className="login-form">
                        <Input
                            label="OTP"
                            type="number"
                            name="otp"
                            value={formData.otp}
                            onChange={handleChange}
                            required
                            placeholder="Enter 6-digit OTP"
                            maxLength="6"
                            disabled={isExpired || isLoading}
                        />

                        <button 
                            type="submit" 
                            className={`login-btn ${isLoading ? 'loading' : ''}`}
                            disabled={isExpired || isLoading}
                        >
                            {isLoading ? 'Verifying...' : 'Verify OTP'}
                        </button>
                    </form>

                    {/* Resend OTP Section */}
                    <div className="resend-section">
                        <p className="resend-text">
                            {isExpired ? (
                                <>
                                    Didn't receive the OTP or it expired?{' '}
                                    <span 
                                        className={`resend-link ${resendLoading ? 'disabled' : ''}`}
                                        onClick={handleResendOtp}
                                    >
                                        {resendLoading ? 'Sending...' : 'Resend OTP'}
                                    </span>
                                </>
                            ) : (
                                <>
                                    Didn't receive the OTP?{' '}
                                    <span 
                                        className={`resend-link ${resendLoading ? 'disabled' : ''}`}
                                        onClick={handleResendOtp}
                                    >
                                        {resendLoading ? 'Sending...' : 'Resend OTP'}
                                    </span>
                                </>
                            )}
                        </p>
                    </div>

                    <div className="register-section">
                        <p className="register-text">
                            <span className="register-link" onClick={handleBackToLogin}>Back to Login</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default VerifyOtp;